import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import DatumReportsList from './datum/reports/index'
import DatumReportShow from './datum/reports/show'
import DatumSettings from './settings/datum'

const AuthenticatedDatum = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate replace to="/datum/reports" />} />
      <Route path="/datum" element={<Navigate replace to="/datum/reports" />} />
      <Route path="/datum/reports" element={<DatumReportsList />} />
      <Route path="/datum/reports/:id" element={<DatumReportShow />} />
      <Route path="/settings" element={<DatumSettings />} />
    </Routes>
  )
}

export default AuthenticatedDatum
